export const supportedNodeAttribues = [
    'weight', 'orgs', 'kr_t', 'kr_modified', 'pr', 'pr_plain', 'myerson_10', 
    'kr_flow', 'kr_flow_weighted', 'rint_flow', 'n3_rank', 'rint'
]
export const nodeLayoutAttribuesNames = {
    'weight': 'Тепловая карта жителей',
    'orgs': 'Тепловая карта огранизаций',
    'kr_t': 'Кирхгофф (турнирная)',
    'kr_modified': 'Кирхгофф (весовой)',
    'pr': 'PageRank',
    'pr_plain': 'PageRank без весов',
    'myerson_10': 'Майерсон k = 10',
    'kr_flow': 'Кирхгофф потоки (турнирная)',
    'kr_flow_weighted': 'Кирхгофф потоки (весовой)',
    'rint_flow': 'Интегральная потоки',
    'n3_rank': 'n = 3',
    'rint': 'Интегральная длины'
}

export const parametersNames = {
    'kr_t': "Кирхгофф (турнирная)",
    'weight': "Число жителей",
    'orgs': 'Число организаций',
    'flow': 'Поток',
    'name': 'Название',
    'length': 'Длина (м)',
    'kr_modified': 'Кирхгофф (весовой)',
    'capacity': "Пропускная способность (авт/ч)",
    'maxspeed': "Ограничение скорости (км/ч)",
    'pr': 'PageRank',
    'time': 'Время проезда (ч)',
    'rint_flow': 'Интегральная потоки',
    'kr_flow': 'Кирхгофф потоки (турнирная)',
    'kr_flow_weighted': 'Кирхгофф потоки (весовой)'
}
export const nodeParameters = ['weight', 'orgs', 'pr', 'rint_flow', 'kr_flow', 'kr_flow_weighted']
export const edgeParameters = ['flow', 'length', 'name', "capacity", 'maxspeed', 'time']
export const parameterPrecision = {
    'weight': 2,
    'orgs': 2,
    'pr': 5,
    'time': 5,
    'length': 2,
    'flow': 2
}